import api from '../../api';
import { ApiSuccessResponse } from '../../types';
import {
  CreateResponse,
  ListResponse,
  ViewResponse,
  UpdateResponse,
  DeleteResponse,
} from './types';

const PAGING_LIMIT = 100;

type ListRes = ApiSuccessResponse<ListResponse>;

const list = () =>
  api.get<ListRes>('/kitchen-groups', {
    params: {
      per_page: PAGING_LIMIT,
    },
  });

type ViewRes = ApiSuccessResponse<ViewResponse>;
const view = (id: string) => api.get<ViewRes>(`/kitchen-groups/${id}`);

type CreatRes = ApiSuccessResponse<CreateResponse>;
const create = (name: string) =>
  api.post<CreatRes>('/kitchen-groups', {
    name,
  });

type UpdateRes = ApiSuccessResponse<UpdateResponse>;
const update = (params: { id: string; name: string }) =>
  api.put<UpdateRes>(`/kitchen-groups/${params.id}`, {
    id: params.id,
    name: params.name,
  });

type DeleteRes = ApiSuccessResponse<DeleteResponse>;
const remove = (id: string) => api.delete<DeleteRes>(`/kitchen-groups/${id}`);

export default { list, view, create, update, remove };
